<template>
<v-container class="pubmed-entry">
  <div class="title">
    <h4>{{entry.title}}</h4>
  </div>
  <div class="authors">{{entry.authors}}.</div>
  <div class="journal">{{entry.journal}}. <span v-if="entry.year">{{entry.year}} {{entry.month}}</span><span v-else>{{entry.pub_date}}</span>;{{entry.issue}}({{entry.volume}}):{{entry.pages}}.</div>
  <div class="buttons pt-3">
    <div v-if="!showMore" class="button small dark mr-5" @click="toggleMore">Read more</div>
    <div v-else class="button small light mr-5" @click="toggleMore">Read less</div>
    <div class="button small" @click="viewPublication">View publication</div>
  </div>
  <div v-if="entry.abstract_objective">
    <div class="description purpose"><span class="label">Purpose:</span> {{entry.abstract_objective}}</div>
    <div :class="`more ` + (showMore ? 'show' : '')">
      <div class="description methods"><span class="label">Methods:</span> {{entry.abstract_methods}}</div>
      <div class="description results"><span class="label">Results:</span> {{entry.abstract_results}}</div>
      <div class="description conclusions"><span class="label">Conclusions:</span> {{entry.abstract_conclusions}}</div>
    </div>
  </div>
  <div v-else>
    <div :class="`description purpose ` + (showMore ? 'hide' : '')"><span class="label">Abstract:</span> {{getShortAbstract}}</div>
    <div :class="`more ` + (showMore ? 'show' : '')">
      <div class="description purpose"><span class="label">Abstract:</span> {{entry.abstract_full}}</div>
    </div>
  </div>
</v-container>
</template>

<script>
export default {
  name: "PubMedEntry",
  props: {
    entry: {
      type: Object,
      default: () => {
        return {  }
      }
    },
  },
  data() {
    return {
      showMore: false,
    }
  },
  watch: {
    entry() {
      this.showMore = false
    }
  },
  computed: {
    getShortAbstract() {
      return this.entry.abstract_full.substring(0, 250) + '...'
    }
  },
  methods: {
    toggleMore(){
        this.showMore = !this.showMore
    },
    viewPublication() {
      window.open( this.getPubMedUrl() )
    },
    getPubMedUrl(){
      return process.env.VUE_APP_PUBMED_URL + this.entry.pubmed_id
    }
  },
}
</script>

<style scoped>

</style>